export default "__VITE_ASSET__Dz2$et1C__"